import { keyframes } from '@emotion/react'

export const iconBounceAnimation = keyframes`
  0%, 100% {
    transform:translate(1.5%,-1.5%)
  }
  50% {
    transform:translate(-1.5%,1.5%)}
  }
`
